var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlider = function SvgSlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.24 6.32H2.91A1.9 1.9 0 0 0 1 8.22v0c0 1.06.85 1.91 1.9 1.91h5.34m6.1-3.8h.76c1.05 0 1.9.85 1.9 1.9v0a1.9 1.9 0 0 1-1.9 1.9h-.76",
    vectorEffect: "non-scaling-stroke"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.29,
    cy: 8.23,
    r: 3.43,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgSlider;